import { OrderStatusKey, Status } from '../../models/order.models';

export const OrderStatuses: Record<OrderStatusKey, Status> = {
  InProgress: { label: 'In Progress', value: 'InProgress', color: '#3E8AEE33' },
  Pending: { label: 'In Progress', value: 'InProgress', color: '#3E8AEE33' },
  AwaitingExchange: {
    label: 'Awaiting Exchange',
    value: 'AwaitingExchange',
    color: '#3E8AEE33',
  },
  AwaitingPayment: {
    label: 'Awaiting Payment',
    value: 'AwaitingPayment',
    color: '#FFA50066',
  },
  ReadyForFulfillment: {
    label: 'Ready For Fulfillment',
    value: 'ReadyForFulfillment',
    color: '#44A04733',
  },
  InPicking: { label: 'In Picking', value: 'InPicking', color: '#3E8AEE33' },
  StagedForDelivery: {
    label: 'Staged For Delivery',
    value: 'StagedForDelivery',
    color: '#FFE20066',
  },
  PartiallyShipped: {
    label: 'Partially Shipped',
    value: 'PartiallyShipped',
    color: '#FFA50066',
  },
  Shipped: { label: 'Shipped', value: 'Shipped', color: '#44A04733' },
  Cancelled: { label: 'Cancelled', value: 'Cancelled', color: '#E5383533' },
  Closed: { label: 'Closed', value: 'Closed', color: '#E5383533' },
  Unknown: { label: 'Unknown', value: 'Unknown', color: '#E5383533' },
  Completed: { label: 'Completed', value: 'Completed', color: '#44A04733' },
  Done: { label: 'Completed', value: 'Completed', color: '#44A04733' },
};
